// extracted by mini-css-extract-plugin
export default {"page":"jNBnuJyoTM019GZFUdsC"};